import { Users, MessageSquare, HeartHandshake } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { scrollTo } from "./Navbar";

const points = [
  {
    icon: Users,
    title: "Small coaching groups",
    body: "We keep numbers low so every trader gets real attention, not a crowd.",
  },
  {
    icon: MessageSquare,
    title: "A private community",
    body: "A dedicated space to ask questions, share progress and stay accountable daily.",
  },
  {
    icon: HeartHandshake,
    title: "Mentors who care",
    body: "Direct feedback from people invested in your long term growth as a trader.",
  },
];

export default function Community() {
  return (
    <section
      id="community"
      className="relative py-24 sm:py-32 lg:py-40 border-t border-white/5"
      data-testid="community-section"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <Reveal>
          <SectionLabel>The Community</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight max-w-2xl">
            You never trade alone.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-4 text-sm text-zinc-500 font-light max-w-xl">
            Trading can be lonely. At MBM you grow alongside a serious, supportive group of traders
            all working toward the same standard.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          {points.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={p.title} delay={i * 0.12}>
                <div className="glass-card h-full p-8" data-testid={`community-card-${i}`}>
                  <div className="h-12 w-12 rounded-full flex items-center justify-center border border-white/10">
                    <Icon strokeWidth={1.25} className="h-5 w-5 text-[#9fd3ff]" />
                  </div>
                  <h3 className="mt-6 font-heading text-xl font-light">{p.title}</h3>
                  <p className="mt-3 text-sm text-zinc-400 font-light leading-relaxed">{p.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2}>
          <button
            onClick={() => scrollTo("apply")}
            className="btn-glass mt-12 text-white px-8 py-4 text-sm font-medium tracking-wide"
            data-testid="community-apply-btn"
          >
            Join the Community
          </button>
        </Reveal>
      </div>
    </section>
  );
}
